import { CartOutlineIcon } from './CartOutlineIcon';

/**
 * author: Google
 * id F290ABB0-4CD2-4C45-B543-E3AEBA1FE358
 * name cart-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart-outline.svg
 * tags
 * - Shopping 
 */
export const TrolleyOutlineIcon = CartOutlineIcon;
export default TrolleyOutlineIcon